import { AboutStats } from "@kunduz/ui-components";
import React, { ReactElement } from "react";

export const TrChangeInEducationStats = (): ReactElement => {
  return (
    <AboutStats
      desc="Öğrencileri hayallerini gerçekleştirebilecek pozisyona getiren, sadece kendilerine ve kendi hedeflerine yönelik kullanabilecekleri eğitimi sunarak onları güçlendirmek "
      imageUrl="https://media.kunduz.com/cms/media/IV_2.webp"
      title="Değişmesi gerekenleri değiştirip eğitimi dönüştürmeye devam ediyoruz. "
      items={[
        {
          label: "Kunduz’la çözüme kavuşan soru sayısı",
          value: "150M+",
        },
        {
          label: "Türkiye genelinde Kunduz’dan yararlanan öğrenci sayısı",
          value: "5M+",
        },
        {
          label: "Öğrencilere destek veren eğitmen sayısı",
          value: "98 bin+",
        },
        {
          label: "Dünya genelinde Kunduz’dan yararlanan öğrenci sayısı",
          value: "10M+",
        },
      ]}
    />
  );
};
